<!-- The ref attr used to find the swiper instance -->
<template>
<div class="swiper-one">
  <h3>{{swiperTitle}}</h3>
  <div class="swiper-container">
      <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperData" :key="index">
            <!-- 物联网关状态 -->
            <div v-if="item.device_name">
              <img v-if="item.equipment_staus=='正常'" :src="imgUrlNormal" alt="">
              <img v-if="item.equipment_staus!='正常'" :src="imgUrlAbnormal" alt="">
              <h4>{{item.device_name}}</h4>
              <p v-if="item.mac_address" :class="{'danger':item.equipment_staus!='正常'}">{{item.mac_address}}</p>
            </div>
            
            <!-- 环境 -->
            <div v-if="item.name">
              <img v-if="item.is_healthy=='Y'" :src="imgUrlNormal" alt="">
              <img v-if="!item.is_healthy || item.is_healthy!='Y'" :src="imgUrlAbnormal" alt="">
              <h4>{{item.name}}</h4>
              <p v-if="item.value" :class="{'danger':!item.is_healthy || item.is_healthy!='Y'}">{{item.value}}{{item.unit}}</p>
            </div>
            <!-- 动力设施 -->
            <div v-if="item.cn_name">
              <img v-if="item.is_healthy=='Y'" :src="imgUrlNormal" alt="">
              <img v-if="!item.is_healthy || item.is_healthy!='Y'" :src="imgUrlAbnormal" alt="">
              <h4>{{item.cn_name}}</h4>
            </div>
          </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev swiper-button-white"></div>
      <div class="swiper-button-next swiper-button-white"></div>
      
      <!-- 如果需要滚动条 -->
      <div class="swiper-scrollbar"></div>
  </div>
</div>
  
</template>

<script>
  
</script>
<script>
import Swiper from 'swiper';
export default {
  name: '',
  // 名称、数据、正常设备图标、异常设备图标
  props:['swiperTitle','swiperData','imgUrlNormal','imgUrlAbnormal'],
  data () {
    return {

    }
  },  
  mounted(){
     new Swiper('.swiper-container', {
	      slidesPerView: 7,
	      spaceBetween: 30,
        slidesPerGroup: 1,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
	      loop: false,
	      autoplay: false,
	      loopFillGroupWithBlank: true,
	     
	      nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
	    })       
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/gatewaySwiper.vue